import { ColorUpdater } from "./ColorUpdater";
export async function loadColorUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("color", (container) => new ColorUpdater(container), refresh);
}
